// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3_1oP","overflowing":"ReadFullNote_overflowing__2GVE8"};